import "./PortfolioRoadmapRowLabels.css";

import { forwardRef } from "react";

import { OrganisationTypeConstants } from "../../../../../constants";
import { getDealListingRoute } from "../../../../../utils/routes";
import { PortfolioRoadmapRowLabelData } from "../../models";

interface PortfolioRoadmapRowLabelsProps {
  data: PortfolioRoadmapRowLabelData;
  headerLabel?: string;
}

export const PortfolioRoadmapRowLabels = forwardRef<HTMLDivElement, PortfolioRoadmapRowLabelsProps>(
  ({ data, headerLabel = "Deal" }, forwardedRef): JSX.Element => {
    return (
      <div ref={forwardedRef} className="PortfolioRoadmapRowLabels">
        <div className="RowLabel Header">
          <h3>{headerLabel}</h3>
        </div>
        {data.map((row) => (
          <div key={row.displayName}>
            <div className={`RowLabel ${!row.additionalDates ? "Small" : ""}`}>
              <a href={getDealListingRoute(row.uuid ?? "", OrganisationTypeConstants.ASSET_MANAGER)}>
                <p className="body2">
                  <b>{row.displayName}</b>
                </p>
              </a>
              {row.subtitle && <p className="body3">{row.subtitle}</p>}
            </div>
          </div>
        ))}
      </div>
    );
  }
);
